// Etapa 15: formulário de cadastro do certificado A1.
// A senha do .pfx é o dado mais sensível da tela: fica só no estado do formulário, nunca em
// localStorage, log ou console, e é apagada ao fechar o modal e depois de cada envio.

/** Mesmo limite do servidor (100 KB); acima disso ele recusa o envio. */
export const TAMANHO_MAXIMO_PFX = 100 * 1024;
export const AVISO_ARQUIVO_GRANDE = 'O arquivo do certificado deve ter no máximo 100 KB';
export const AVISO_ARQUIVO_TIPO = 'Escolha um arquivo .pfx ou .p12';

export interface FormularioCertificado {
  file: File | null;
  password: string;
  label: string;
  /** Titular (opcional); vazio = sem titular (seletor "Titular (opcional)" do cadastro, D23). */
  holderId: string;
}

export function formularioVazio(): FormularioCertificado {
  return { file: null, password: '', label: '', holderId: '' };
}

/** Aviso sobre o arquivo escolhido (antes de enviar); null = tudo certo. */
export function avisoDoArquivo(file: Pick<File, 'name' | 'size'> | null): string | null {
  if (!file) return null;
  if (!/\.(pfx|p12)$/i.test(file.name)) return AVISO_ARQUIVO_TIPO;
  if (file.size > TAMANHO_MAXIMO_PFX) return AVISO_ARQUIVO_GRANDE;
  return null;
}

export function podeEnviar(form: FormularioCertificado): boolean {
  return !!form.file && form.password.length > 0 && avisoDoArquivo(form.file) === null;
}

/** Campos exatamente como o servidor espera: file, password, label e (opcional) holder_id. */
export function montarFormData(form: FormularioCertificado): FormData {
  const dados = new FormData();
  if (form.file) dados.append('file', form.file);
  dados.append('password', form.password);
  const rotulo = form.label.trim();
  if (rotulo) dados.append('label', rotulo);
  if (form.holderId) dados.append('holder_id', form.holderId);
  return dados;
}

export interface ResultadoDoEnvio<T> {
  resposta: T | null;
  erro: string | null;
  /** Estado a guardar depois do envio: a senha sempre sai, com ou sem erro. */
  formulario: FormularioCertificado;
}

/** Envia e devolve o formulário já sem a senha (tenha dado certo ou erro). */
export async function enviarEEsquecerSenha<T>(
  form: FormularioCertificado,
  enviar: (dados: FormData) => Promise<T>,
): Promise<ResultadoDoEnvio<T>> {
  const limpo = { ...form, password: '' };
  try {
    const resposta = await enviar(montarFormData(form));
    return { resposta, erro: null, formulario: limpo };
  } catch (err) {
    const erro = err instanceof Error && err.message ? err.message : 'Erro ao cadastrar o certificado.';
    return { resposta: null, erro, formulario: limpo };
  }
}
